import { atomWithReset } from 'jotai/utils'

import { type BrandAccount } from './hooks/useMainQuery'

type DialogInfo =
  | {
      dialogType: 'create'
      brandAccount?: undefined
    }
  | {
      dialogType: 'delete' | 'update'
      brandAccount: BrandAccount
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
